
define("tpl!drops/calendarYearView/calendarYearView.html", ["underscore"], function(_) { return function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="calendar-view year-view">\r\n\r\n    <div class="calendar-title">\r\n        <a class="previous-page clickable no-text-select">〈 </a>\r\n        <a class="next-page clickable no-text-select"> 〉</a>\r\n\r\n        <div class="date-as-title"></div>\r\n    </div>\r\n\r\n    <div class="calendar-main">\r\n    </div>\r\n\r\n</div>';
}
return __p;
};});

